<div class="base-component" (window:resize)="onResize($event)">
  <div class="documentacio incomplerta" [innerHTML]="'ROUTE.PART.INCOMPLETDOCUMENTATION.CAPTION'| translate"
    *ngIf="isIncompletDocument">
  </div>

  <options *ngIf="addOptionMultiFirma || multidocument" class="nomenu" [optionstrip]="optionsMultiDocument" (clickOption)="onClickOptionMultiDocument($event)"></options>
  <options *ngIf="addOptionDetailFirma || documentDetailsLength > 1" class="nomenu" [optionstrip]="optionsMultiDetail" (clickOption)="onClickOptionMultiDetail($event)"></options>

  <ng-container *ngIf="optionMultiDocument == null || optionMultiDocument.optionId=='CMRDigital'">

    <shared-route-ecmr-actions [onlyIcons]="true" [routePartCMRId]="routePartCMRId"></shared-route-ecmr-actions>

    <options class="nomenu" [optionstrip]="optionsCMROrDeliveryNote" (clickOption)="onClickOptionCMROrDeliveryNote($event)"></options>

    <shared-route-part-cmr-digitaldocument-editable-component *ngIf="optionCMROrDeliveryNoteSelected == 'CMR'"
      [external]="external" [routePartCMRId]="routePartCMRId" [readonly]="readonly">
    </shared-route-part-cmr-digitaldocument-editable-component>

    <shared-route-part-shipmentdeliverynote-digitaldocument-component *ngIf="optionCMROrDeliveryNoteSelected == 'DELIVERYNOTE'"
      [external]="external" [routePartCMRId]="routePartCMRId" [readonly]="readonly">
    </shared-route-part-shipmentdeliverynote-digitaldocument-component>

  </ng-container>

  <ng-container *ngIf="documentDetail!=null">

    <shared-document-view-component class="full" [documentDetail]="documentDetail"
      [nominiatures]="true"></shared-document-view-component>

  </ng-container>


  <ng-container *ngIf="hasAccessSignature">
    <div class="ecmr-block signatures">
      <div class="signatura-block">
        <span class="ecmr-block-title">
          {{ 'ROUTEPARTCMRSIGNATUREAGENTS.ENUM.SENDER' | translate}}
        </span>
        <shared-sign-cmr-maintenance class="nomessignagtura nofixed noborder justsignature"
          [routePartCMRId]="routePartCMRId" [type]="'sender'" [readonly]="true"></shared-sign-cmr-maintenance>
      </div>
      <div class="signatura-block">
        <span class="ecmr-block-title">
          {{ 'ROUTEPARTCMRSIGNATUREAGENTS.ENUM.CARRIER' | translate}}
        </span>
        <shared-sign-cmr-maintenance class="nomessignagtura nofixed noborder justsignature"
          [routePartCMRId]="routePartCMRId" [type]="'carrier'" [readonly]="true"></shared-sign-cmr-maintenance>
      </div>
      <div class="signatura-block">
        <span class="ecmr-block-title">
          {{ 'ROUTEPARTCMRSIGNATUREAGENTS.ENUM.CONSIGNEE' | translate}}
        </span>
        <shared-sign-cmr-maintenance class="nomessignagtura nofixed noborder justsignature"
          [routePartCMRId]="routePartCMRId" [type]="'consignee'" [readonly]="true"></shared-sign-cmr-maintenance>
      </div>
      <div class="signatura-block">
        <span class="ecmr-block-title">
          {{ 'ROUTEPARTCMRSIGNATUREAGENTS.ENUM.DRIVER' | translate}}
        </span>
        <shared-sign-cmr-maintenance class="nomessignagtura nofixed noborder justsignature"
          [routePartCMRId]="routePartCMRId" [type]="'driver'" [readonly]="true"></shared-sign-cmr-maintenance>
      </div>
    </div>
  </ng-container>
</div>